import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { statisticsKeys } from "./keys.ts";
import { getQualityStatistics } from "../api.ts";
import type { QualityStatistic } from "../../types.ts";

export const useQualityStatisticsQuery = (
  fromDate?: string,
  toDate?: string,
) => {
  return useQuery<QualityStatistic[]>({
    queryKey: statisticsKeys.quality(fromDate, toDate),
    queryFn: async () => {
      const { data } = await getQualityStatistics(fromDate, toDate);
      return data.data;
    },
    ...reactQueryCacheAndRefetchOptions,
  });
};
